import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AdminGuard } from "../guards/admin/admin.guard";
import { AuthenticatedGuard } from "../guards/authentication/authenticated.guard";
import { NotAuthenticatedGuard } from "../guards/authentication/not-authenticated.guard";
import { PortalkonfigurationResolver } from "../resolver/portalkonfiguration/portalkonfiguration.resolver";
import { CurrentUserResolver } from "../resolver/user/current-user.resolver";
import { UserModelResolver } from "../resolver/user/user-model.resolver";
import { AuthenticationShellComponent } from "../shell/authentication-shell/authentication-shell.component";
import { ShellComponent } from "../shell/shell/shell.component";
import { UserSettingsResolver } from "../resolver/user/user-settings.resolver";
import { PortalTypGuard } from "../guards/portal-typ.guard";
import { GlobalEnumsAcePortaltyp } from "@/api/model-index";

export class AppRoutingFactory extends BaseRoutingFactory {

  private readonly coreAppRoute: Routes = [
    {
      path: '',
      component: ShellComponent,
      resolve: {
        portalkonfiguration: PortalkonfigurationResolver,
        user: CurrentUserResolver,
        userModel: UserModelResolver,
        userSettings: UserSettingsResolver,
      },
      canActivate: [AuthenticatedGuard],
      children: [
        {
          path: '',
          loadChildren: () => import('@/core/features/ausschreibung/ausschreibung.module').then(m => m.AusschreibungModule),
          canActivate: [PortalTypGuard],
          data: {portaltyp: GlobalEnumsAcePortaltyp.Forderung}
        },
        {
          path: 'anfrage',
          loadChildren: () => import('@/core/features/anfrage/anfrage.module').then(m => m.AnfrageModule),
          canActivate: [PortalTypGuard],
          data: {portaltyp: GlobalEnumsAcePortaltyp.Forderung}
        },
        {
          path: 'chat',
          loadChildren: () => import('@/core/features/chat/chat.module').then(m => m.ChatModule)
        },
        {
          path: 'review',
          loadChildren: () => import('@/core/features/review/review.module').then(m => m.ReviewModule),
          canActivate: [PortalTypGuard],
          data: {portaltyp: GlobalEnumsAcePortaltyp.Begutachtung}
        },
        {
          path: 'admin',
          loadChildren: () => import('@/core/features/admin/admin.module').then(m => m.AdminModule),
          canActivate: [
            AdminGuard
          ]
        }
      ]
    },
    {
      path: 'authentication',
      component: AuthenticationShellComponent,
      loadChildren: () => import('@/core/components/authentication/authentication.module').then(m => m.AuthenticationModule),
      canActivate: [NotAuthenticatedGuard],
      resolve: {
        portalkonfiguration: PortalkonfigurationResolver
      }
    },
    { path: '**', redirectTo: '' }, //if queried route is not found navigate to root
  ];

  public create(): Routes {
    const coreRoute = this.coreRoute;

    return coreRoute;
  }

  protected get coreRoute(): Routes {
    return this.coreAppRoute;
  }

  protected registerChild(coreRoute: Routes, route: Route): void {
    const formRoutes = coreRoute![0].children!;
    const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
    if (foundIndex >= 0) {
      formRoutes[foundIndex] = route;
    }
    else {
      coreRoute![0].children!.push(route);
    }
  } 
}